import { useState } from 'react';
import { IconButton } from '@/shared/ui/IconButton/IconButton';
import Refresh from '@/shared/assets/icons/refresh.svg';
import { RestoreAccountModal } from '../RestoreAccountModal/RestoreAccountModal';
import { useScreenDetector } from '@/shared/lib/hooks/useScreenDetector';

interface RestoreAccountButtonProps {
  userId: number;
  userName: string;
  mode?: 'account' | 'club';
}

export const RestoreAccountButton = ({ userId, userName, mode = 'account' }: RestoreAccountButtonProps) => {
  const [open, setOpen] = useState(false);
  const { isMobile } = useScreenDetector();

  return (
    <>
      <IconButton
        size={isMobile ? 'xs' : 'm'}
        color="green"
        onClick={() => setOpen(true)}
        title={mode === 'club' ? 'Восстановить клуб' : 'Восстановить аккаунт'}
      >
        <Refresh />
      </IconButton>
      {open ? (
        <RestoreAccountModal
          open={open}
          userId={userId}
          userName={userName}
          mode={mode}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
};
